module.exports = __webpack_public_path__ + "img/DESIGN_08.911b1892.jpg";